import React, { useEffect, useState } from "react";
import "./../../../styles/login/portal/consultas.css";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import axios from "axios";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { BaseUrlInfo } from "../../../services/axios/AxiosEndpoints";
import styled from "@emotion/styled";
import {
  Box,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  tableCellClasses,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import DOMPurify from "dompurify";

const SearchData = () => {
  /* --------------------------------- Datos del usuario y de respuesta del servidor ------------------------------ */

  /* Variable que almacena los datos */
  const [auths, setAuths] = useState([]);
  /* Variable que almacena la fecha de inicio */
  const [fechaInicio, setFechaInicio] = useState();
    /* Variable que almacena la fecha final */
  const [fechaFin, setFechaFin] = useState();
  /* Variable que almacena la fecha de la tabla */
  const [fechaTabla, setFechaTabla] = useState();
  /* Variable que almacena el codigo del afiliado */
  const [plastico, setPlastico] = useState("");
  /* Datos almacenados en redux */
  const { autorizaciones } = auths;
  /* Datos almacenados en redux */
  const { usuario, clave, codPss } = useSelector((state) => state.user);

  /* --------------------------------- Estilos de la tabla ------------------------------ */

  const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#46cffa",
      color: "#fff",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(() => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "#ccc",
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  /* --------------------------------- Datos de la tabla ------------------------------ */

  const columns = [
    { id: "codAutorizacion", label: "NÚMERO DE AUTORIZACIÓN", Width: "auto" },
    { id: "plastico", label: "PÓLIZA", Width: "auto" },
    { id: "fecha", label: "FECHA", Width: "auto" },
  ];

  /* --------------------------------- Paginación de la tabla  ------------------------------ */

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  /* --------------------------------- Funcion que captura la fecha de inicio ------------------------------ */

  const HandleFechaInicio = (Date) => {
    setFechaInicio(Date);
  };

  /* -------------------------------- Funcion que captura la fecha final ------------------------------- */

  const HandleFechaFin = (Date) => {
    setFechaFin(Date);
  };

  /* --------------------------------- Funcion que captura el codigo del afiliado ------------------------------ */

  const HandlePlastico = (e) => {
    const { value } = e.target;
    setPlastico(value);
  };

  /* ---------------------------------  Actualiza la fecha al montar el componente ------------------------------ */

  useEffect(() => {
    if (Array.isArray(autorizaciones)) {
      const [fecha] = autorizaciones?.map((item, index) => item.fecha);

      if (fecha) {
        setFechaTabla(fecha.substring(0, 10));
      }
    }
  }, [autorizaciones]);

  /* --------------------------------- Validaciones ------------------------------ */

  const validate = () => {
    const errors = {};

    if (!fechaInicio) {
      errors.fechaInicio = "Este campo no puede estar vacío";
    }

    if (!fechaFin) {
      errors.fechaFin = "Este campo no puede estar vacío";
    }

    return errors;
  };

  /* --------------------------------- Fecha que envie la peticion al servidor ------------------------------ */

  const HandleconsultDateSubmit = async (e) => {
    e.preventDefault();

    const fechainicio = new FormData();
    const fechafin = new FormData();

    fechainicio.append("files", fechaInicio);
    fechafin.append("files", fechaFin);

    const sanitizedFechaInicio = DOMPurify.sanitize(format(new Date(fechaInicio), "yyyy-MM-dd"));
    const sanitizedFechaFin = DOMPurify.sanitize(format(new Date(fechaFin), "yyyy-MM-dd"));
    const sanitizedPlastico = DOMPurify.sanitize(plastico);

    await axios({
      url: `${BaseUrlInfo}/listarAutorizaciones`,
      method: "POST",
      data: JSON.stringify({
        auth: {
          usuario: usuario,
          password: clave,
          codPss: codPss,
        },
        fechaInicio: sanitizedFechaInicio,
        fechaFin: sanitizedFechaFin,
        canalActual: false,
        plastico: sanitizedPlastico,
      }),
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status === 200) {
          setAuths(response.data);
        }
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 400) {
            //setErrors("El recurso no fue encontrado.");
          } else if (error.response.status === 422) {
            //setErrors("El recurso no fue procesado.");
          } else if (error.response.status === 500) {
            //setErrors("Ha ocurrido un error en el servidor");
          }

          let { resp } = error.response.data;
          Swal.fire({
            title: "",
            text: resp.mensaje,
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (error.request) {
          Swal.fire({
            title: "warning!",
            text: error.request,
            icon: "warning",
            confirmButtonText: "Ok",
          });
        }
      });
  };

  /* --------------------------------- ------------------------------ */

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <div className="contenedor-central">
        <Container maxWidth="lx">
          <h5 className="text-center mt-4 ">
            CONSULTA DE AUTORIZACIONES POR RANGO DE FECHA
          </h5>

          <Box
            sx={{
              width: "100%",
            }}
          >
            <div className="row ">
              <Box
                sx={{
                  width: "100%",
                }}
              >
                <form autoComplete="off" onSubmit={HandleconsultDateSubmit}>
                  <div className="row d-flex flex-row justify-content-center ">
                    <div className="col-auto  d-flex flex-column justify-content-around ">
                      <div className="row d-flex flex-row justify-content-center ">
                        <Box
                          sx={{
                            width: {
                              xs: "100%",
                              sm: "100%",
                              md: "50%",
                              lg: "50%",
                            },
                            display: "flex",
                            flexDirection: {
                              xs: "column",
                              sm: "column",
                              md: "column",
                              lg: "column",
                            },
                            justifyContent: "center",
                            alignItems: "center",
                            mt: 4,
                            mb: 2,
                          }}
                        >
                          <Typography
                            sx={{
                              width: "auto",
                              fontSize: 22,
                              fontWeight: 500,
                              marginRight: "35px",
                              marginBottom: "25px",
                            }}
                          >
                            Fecha Inicio
                          </Typography>

                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DemoContainer components={["DatePicker"]}>
                              <DatePicker
                                label="Fecha"
                                name="fechaInicio"
                                defaultValue={fechaInicio}
                                onChange={HandleFechaInicio}
                                slotProps={{
                                  textField: {
                                    helperText: validate().fechaInicio,
                                  },
                                }}
                                sx={{
                                  width: {
                                    xs: "100%",
                                    sm: "100%",
                                    md: "50%",
                                    lg: "50%",
                                  },
                                }}
                              />
                            </DemoContainer>
                          </LocalizationProvider>
                        </Box>

                        <Box
                          sx={{
                            width: {
                              xs: "100%",
                              sm: "100%",
                              md: "50%",
                              lg: "50%",
                            },
                            display: "flex",
                            flexDirection: {
                              xs: "column",
                              sm: "column",
                              md: "column",
                              lg: "column",
                            },
                            justifyContent: "center",
                            alignItems: "center",
                            mt: 4,
                            mb: 2,
                          }}
                        >
                          <Typography
                            sx={{
                              width: "auto",
                              fontSize: 22,
                              fontWeight: 500,
                              marginRight: "35px",
                              marginBottom: "25px",
                            }}
                          >
                            Fecha Final
                          </Typography>

                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DemoContainer components={["DatePicker"]}>
                              <DatePicker
                                label="Fecha"
                                name="fechaFin"
                                defaultValue={fechaFin}
                                onChange={HandleFechaFin}
                                slotProps={{
                                  textField: {
                                    helperText: validate().fechaFin,
                                  },
                                }}
                                sx={{
                                  width: {
                                    xs: "100%",
                                    sm: "100%",
                                    md: "50%",
                                    lg: "50%",
                                  },
                                }}
                              />
                            </DemoContainer>
                          </LocalizationProvider>
                        </Box>
                      </div>

                      <div className="row d-flex flex-row justify-content-center align-items-center mt-5">
                        <div className="col-auto p-0 m-0">
                          <label
                            className="text-center "
                            id="plastico-p"
                            htmlFor="plastico"
                          >
                            PÓLIZA
                          </label>

                          <input
                            type="text"
                            className="form-control text-left mx-1"
                            placeholder="OPCIONAL"
                            id="plastico"
                            name="plastico"
                            value={plastico}
                            onChange={HandlePlastico}
                          />
                        </div>
                        <div className="col-auto p-0 m-0">
                          <button
                            type="submit"
                            className="btn btn-success ms-4 mt-4"
                          >
                            ENVIAR
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </Box>
            </div>
          </Box>

          <Box
            sx={{
              width: "100%",
            }}
          >
            <div className="row mt-5 d-flex flex-column align-items-center ">
              <div className="col-auto ">
                <Paper sx={{ width: "100%", overflow: "hidden" }}>
                  <TableContainer sx={{ maxHeight: 600 }}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <StyledTableRow>
                          {columns.map((column) => (
                            <StyledTableCell
                              key={column.id}
                              align={column.align}
                              style={{ width: column.Width }}
                            >
                              {column.label}
                            </StyledTableCell>
                          ))}
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>
                        {autorizaciones
                          ?.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((item, index) => {
                            return (
                              <StyledTableRow key={index}>
                                <TableCell>{item.codAutorizacion}</TableCell>
                                <TableCell>{item.plastico}</TableCell>
                                <TableCell>{fechaTabla}</TableCell>
                              </StyledTableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 100]}
                    component="div"
                    count={autorizaciones?.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Paper>
              </div>
            </div>
          </Box>

          <footer className="py-4 ">
            <div className="container p-0 m-0">
              <div className="d-flex align-items-center justify-content-center small">
                <div className="text-muted">Copyright © ARS RENACER 2023</div>
              </div>
            </div>
          </footer>
        </Container>
      </div>
    </Box>
  );
};

export default SearchData;
